import React from "react";
var __jsx = React.createElement;
var FlowScreenHeaderSpacing = function FlowScreenHeaderSpacing(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0 px-4 pt-4 pb-2 flex flex-col gap-2 md:gap-6 md:pb-10"
  }, children));
};
export default FlowScreenHeaderSpacing;